import { render } from "./IconBriefcase.vue.js?vue&type=template&id=4ffa3568!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconBriefcase.vue?vue&type=template&id=4ffa3568"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__